<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="96%">
        <Spin size="large" fix v-if="loading"></Spin>

        <div class="detail-box">
            <div class="box-header">
                <div class="box-header-val">检测结果：{{statusText}}</div>
                <div class="box-header-val">烟度值：{{smokeText}}</div>
                <div class="box-header-val">发动机转速：{{rpmText}}</div>
            </div>
            <div class="box-body">
                <div class="box-chart">
                    <div id="smoke-chart" style="width:48%;"></div>
                    <div id="rpm-chart" style="width:48%;"></div>
                </div>
            </div>
        </div>

        <div slot="footer">
            <Button @click="currValue=false">关闭</Button>
        </div>
    </Modal>
</template>

<script>
    import iExam from '@/module/main/api/iExam'
    import modalHelper from "@/mixins/modalHelper";
    import _don from "@/libs/doson";
    import { Line } from '@antv/g2plot';

    const formModal = {
        id:null,
        department:{id:null},
        dataType:null,
        instrumentType:null,
        instrumentNo:null,
        instrumentManu:null,
        communicationMode: 1,
        cmaNo:null,
        addTime:null
    };
    var applyChartData = [];
    var applySmokePlot = null;

    export default {
        name: "exam-data",
        mixins: [modalHelper],
        components: {
        },
        props: {
            applyId: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                formData: _don.cloneWithModal(formModal),
                smokePlot:null,
                rpmPlot:null,
                statusText: null,
                smokeText: null,
                rpmText: null,
                minRpm:10000,
                minSmoke:10,
                intervalId:0,
                previousLength:0
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                applySmokePlot = new Line(document.getElementById('smoke-chart'), {
                    title: {
                        visible: true,
                        text: '烟度值曲线图',
                    },
                    /*description: {
                        visible: true,
                        text: '烟度值曲线图',
                    },*/
                    padding: 'auto',
                    forceFit: true,
                    data:applyChartData,
                    xField: 'stageIndex',
                    yField: 'smokeValue',
                    seriesField:'testIndex',
                    legend: {
                        position: 'top-right',
                    },
                    smooth: true,
                });

                applySmokePlot.render();

                this.rpmPlot = new Line(document.getElementById('rpm-chart'), {
                    title: {
                        visible: true,
                        text: '转速曲线图',
                    },
                    /*description: {
                        visible: true,
                        text: '转速曲线图',
                    },*/
                    padding: 'auto',
                    forceFit: true,
                    data:applyChartData,
                    xField: 'stageIndex',
                    yField: 'rpmValue',
                    seriesField:'testIndex',
                    legend: {
                        position: 'top-right',
                    },
                    smooth: true,
                });

                this.rpmPlot.render();

                console.log('chart inited!')
            },
            setFormData() {
                this.previousLength = 0
                this.getApplyData()
            },
            getApplyData() {
                iExam.applytDetail(this.applyId).then(res => {
                    if (res.status == 2) {
                        this.statusText = res.qualified == 1 ? '合格' : '不合格'
                        this.smokeText = res.smokeVal
                        this.rpmText = res.realSpeed
                    } else if (res.status == 3) {
                        this.statusText = this.smokeText = this.rpmText = '已取消'
                    } else {
                        this.statusText = this.smokeText = this.rpmText = '检测中'
                        this.intervalId = window.setTimeout(()=>{
                            this.getApplyData()
                        }, 1000)
                    }
                    /*if (res.data.length <= 0 || this.previousLength == res.data.length) {
                        return
                    }*/
                    this.previousLength = res.data.length
                    let stageIndex = 1;
                    let testIndex = 1
                    let testIndexName = '第一次'
                    let minRpm = 10000
                    let minSmoke = 10
                    applyChartData = res.data.map(e => {
                        if (testIndex != e.test_index) {
                            testIndex = e.test_index
                            stageIndex = 1
                            testIndexName = ['','','第二次','第三次'][e.test_index]
                        }
                        if (e.smoke_val < minSmoke) {
                            minSmoke = e.smoke_val
                        }
                        if (e.real_speed < minRpm) {
                            minRpm = e.real_speed
                        }
                        return {testIndex:testIndexName, stageIndex:stageIndex++, smokeValue:e.smoke_val, rpmValue:e.real_speed};
                    })
                    if (minSmoke < this.minSmoke || Math.abs(minSmoke - this.minSmoke) > 0.05) {
                        applySmokePlot.updateConfig({
                            yAxis:{
                                min:minSmoke-0.05
                            },
                            data:applyChartData
                        })
                        applySmokePlot.render()
                    } else {
                        applySmokePlot.changeData(applyChartData)
                    }
                    if (minRpm < this.minRpm || Math.abs(minRpm - this.minRpm) > 50) {
                        this.rpmPlot.updateConfig({
                            yAxis: {
                                min: minRpm - 50
                            },
                            data: applyChartData
                        });
                        this.rpmPlot.render();
                    } else {
                        this.rpmPlot.changeData(applyChartData)
                    }
                    this.minSmoke = minSmoke;
                    this.minRpm = minRpm
                }).catch(err => {
                    applyChartData = []
                    applySmokePlot.changeData(applyChartData)
                    this.rpmPlot.changeData(applyChartData)
                    this.$Message.error(err)
                })
            },
        },
        computed: {
            title() {
                return '检测详情';
            }
        },
        watch:{
            currValue(val) {
                // 关闭窗口
                if (!val && this.value !== val) {
                    this.$refs.form && this.$refs.form.resetFields()
                    this.$nextTick(()=> {
                        this.$emit('input', false);
                    })
                    this.intervalId && window.clearTimeout(this.intervalId)
                    this.invervalId = 0
                }
            }
        }
    }
</script>

<style scoped>
    .box-header {
        color:#000000;
        font-size:24px;
        line-height:28px;
        width:100%;
        display: flex;
        justify-content: center;
    }
    .box-header-val{
        flex:1
    }
    .box-chart{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
</style>
